import React, { useContext } from 'react';
import { Box, Container, Header, Table } from '@amzn/awsui-components-react';
import { AppContext } from '../../../utils/appContext';
import { transformConnections } from './utils';
import { columnDefinitions } from './constants';
import { useCrossClusterConnectionsQuery } from './hooks/useCrossClusterConnectionsQuery';

interface CrossClusterSectionProps {
  domainIdentifier: string;
}

// Overview shows a control-plane-only connections list (no data-plane calls).
// Role badge + connection Type live in the Cross-Cluster Insights tab, which is
// where the replication stats are fetched.
const CrossClusterSection = (props: CrossClusterSectionProps) => {
  const appContext = useContext(AppContext);
  const stage = appContext?.stage;

  const { loading, data, error } = useCrossClusterConnectionsQuery({
    domainIdentifier: props.domainIdentifier,
    includeReplicationStats: false,
  });

  const result = data?.crossClusterConnections;
  const outbound = result?.outboundConnections ?? [];
  const inbound = result?.inboundConnections ?? [];

  const connections = transformConnections(outbound, inbound, stage);

  // Hide the section while loading and when the domain has no connections.
  if (loading) return null;
  if (!error && connections.length === 0) return null;

  const header = <Header variant="h2">Cross-Cluster Connections</Header>;

  const content = error ? (
    <Box textAlign="center" padding="m" color="text-status-error">
      Unable to fetch cross-cluster connections.
    </Box>
  ) : (
    <Table
      variant="embedded"
      columnDefinitions={columnDefinitions}
      items={connections}
      resizableColumns={false}
      wrapLines={true}
    />
  );

  return <Container header={header}>{content}</Container>;
};

export { CrossClusterSection };
